module.exports = __webpack_public_path__ + "static/media/gain_title.6f9499b6.png";